'use client';

import { useRouter } from 'next/navigation';
import { EasyAccess } from '@/features/tag';
import { IRANIAN_WOMEN_CATEGORIES } from '../../constants';
interface Props {
  selectedCategory: string | null;
}
const SliderFilters = ({
  selectedCategory
}: Props) => {
  const router = useRouter();
  return <div className='hide-scrollbar relative flex w-full items-center justify-start gap-2 overflow-auto lg:justify-center' data-sentry-component="SliderFilters" data-sentry-source-file="slider-filters.tsx">
            {IRANIAN_WOMEN_CATEGORIES.map(category => {
      const showAllCategories = !category.id;
      return <EasyAccess key={category.id} sendEvents={false} size='large' showClose={false} isActive={category.id === selectedCategory || showAllCategories && !selectedCategory} className='keen-slider__slide min-w-fit max-w-fit' onClick={() => showAllCategories ? router.replace('/iranian-women', {
        scroll: false
      }) : router.replace(`?category=${category.id}`, {
        scroll: false
      })}>
                        {category.name}
                    </EasyAccess>;
    })}
        </div>;
};
export default SliderFilters;